export const environment = {
  COMPANY_NAME: 'evollo',
  APP_NAME: 'ADMIN',
  production: false,
  apiUrl: "https://cancaonova-account.api.evollo.cloud",
  qualityApiUrl: "https://cancaonova-quality.api.evollo.cloud",
  enabledChat: false,
  apps: {
    id: "https://cancaonova.id.evollo.com.br/",
    quality: "https://cancaonova.quality.evollo.com.br",
  },
	features: {
				enabledChat: false,
		enableOrgCreation: false,
		enableSupport: false,
		enableFaq: false,
    enableMicrosoftLogin: false
	}
};
